<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="success"
      @click="init"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-plus
    </v-icon>

    <slot/>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        :scrollable="true"
        max-width="750"
    >
      <v-card>
        <v-card-title>
          Vytvoriť administrátora

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
              @submit.stop.prevent="submit"
          >
            <v-row>
              <v-col
                  cols="12"
                  lg="6"
              >
                <v-text-field
                    v-model="AdminForm.name"
                    :error-messages="errors.name"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Meno"
                />
              </v-col>

              <v-col
                  cols="12"
                  lg="6"
              >
                <v-text-field
                    v-model="AdminForm.username"
                    :error-messages="errors.username"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Užívateľské meno"
                />
              </v-col>

              <v-col
                  cols="12"
                  lg="6"
              >
                <v-text-field
                    v-model="AdminForm.email"
                    :error-messages="errors.email"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="E-mail"
                    type="email"
                />
              </v-col>

              <v-col
                  cols="12"
                  lg="6"
              >
                <v-text-field
                    v-model="AdminForm.phone"
                    :error-messages="errors.phone"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Telefón"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-select
                    v-model="AdminForm.type"
                    :error-messages="errors.type"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Typ"
                    :items="$store.getters['register/getAdminType']"
                    no-data-text="Žiadne výsledky"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-checkbox
                    v-model="AdminForm.agreementGdpr"
                    :error-messages="errors.agreementGdpr"
                    :dense="true"
                    hide-details="auto"
                    label="Súhlasím so spracovaním osobných údajov"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-btn
                    type="submit"
                    :rounded="true"
                    :outlined="true"
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>

                  Vytvoriť
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Admins from '@/services/admins'

  export default {
    name: 'Create',
    data() {
      return {
        loading: false,
        dialog: false,
        AdminForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = true

        this.AdminForm = {
          name: '',
          username: '',
          email: '',
          phone: '',
          type: this.$store.state.register.Admin.type['worker'].value,
          agreementGdpr: false
        }

        this.errors = {}
      },
      async submit() {
        this.loading = true

        await Admins
          .create({
            data: this.AdminForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
